import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { useState } from "react";

import { t } from "@/i18n-js/instance";
import { accountSubscriptionApi } from "@/react/api/accountSubscriptionApi";

import { UPGRADE_PATHS } from "../constants";
import { useUpgradePlanNavigate } from "../upgradePlanRouterHelpers";
import { useAccountPaymentProcessorsApi } from "./useAccountPaymentProcessorsApi";

const i18nRoot = "pricing_plans.upgrade_modal";

interface LoadingMessage {
  subtitle: string;
  title: string;
}

export const useRenewalHandler = (source?: string) => {
  const navigate = useUpgradePlanNavigate();
  const { createCheckoutSession } = useAccountPaymentProcessorsApi();
  const { refetchCurrentPlan } = useCurrentPlanApi();
  const [loadingMessage, setLoadingMessage] = useState<LoadingMessage>({
    title: t([i18nRoot, "loading.loading"]),
    subtitle: "",
  });

  const attemptRenewal = async (planId: number) => {
    try {
      setLoadingMessage({
        title: t([i18nRoot, "loading.loading"]),
        subtitle: "",
      });

      await accountSubscriptionApi.renew(planId);
      await refetchCurrentPlan();

      void navigate({ to: UPGRADE_PATHS.UPGRADE_SUCCESSFUL });
    } catch {
      setLoadingMessage({
        title: t([i18nRoot, "stripe_checkout_title"]),
        subtitle: "",
      });

      createCheckoutSession({
        plan_id: planId,
        source: source || "",
      });
    }
  };

  return {
    attemptRenewal,
    loadingMessage,
  };
};
